import React, { Component } from 'react';
import { numberWithCommas } from './numberWithCommas';

class BoldCashFormatter extends Component {
  render() {
    const { value } = this.props;
    return (
      <span style={{ 'font-weight': 'bold' }}>
        {
          (value !== null && !isNaN(value) && `$${numberWithCommas(value)}`)
        }
      </span>
    );
  }
}

export default BoldCashFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/boldCashFormatter.jsx